import React from 'react'
import { Dialog, DialogBody } from '@material-tailwind/react'
import { XMarkIcon } from '@heroicons/react/24/solid'
import { useApplyStore } from '../../stores/ui/applyStore'
import { ApplicationForm } from './ApplicationForm'
import { useApplyFormStore } from '../../stores/ui/applyFormStore'

export const ApplicationModalForm = ({
  backendUrl,
  frontStrapiToken,
}: {
  backendUrl: string
  frontStrapiToken: string
}) => {
  const { isApplicationFormModalOpen, closeApplicationFormModal } =
    useApplyStore()

  const resetStateButkeepPersonalInfo = useApplyFormStore(
    (state) => state.resetStateButkeepPersonalInfo,
  )

  function close() {
    resetStateButkeepPersonalInfo()
    closeApplicationFormModal()
  }

  return (
    <Dialog
      open={isApplicationFormModalOpen}
      handler={() => close()}
      size="md"
      className="bg-transparent"
    >
      <div className="flex flex-col items-center py-6 bg-transparent">
        <DialogBody className="relative max-h-[90vh] px-4 md:px-6 py-2 md:py-4 overflow-y-scroll bg-white rounded-lg no-scrollbar">
          <button
            type="button"
            className="absolute transition-transform duration-700 ease-in-out top-4 right-4 hover:rotate-90 hover:text-night"
            onClick={close}
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
          <ApplicationForm
            backendUrl={backendUrl}
            frontStrapiToken={frontStrapiToken}
          />
        </DialogBody>
      </div>
    </Dialog>
  )
}
